import Button from "components/button";
import ButtonIcon from "components/button-icon";
import IconAddSmall from "components/icons/icn-add-small-blue.icon";
import { IconTrash } from "components/icons/icn-index.icon";
import { OpenSuggestionPanelContext } from "components/suggestion-context/context/openSuggestionPanelContext";
import StockReturnNotificationModal from "pages/suggestions/components/stock-return-notification-modal";
import {
  getOtherSuggestions,
  getStockReturnSuggestions,
} from "pages/suggestions/utils/suggestion-type";
import PropTypes from "prop-types";
import { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import intl from "react-intl-universal";
import {
  getListCodeHeaderAbbreviated,
  usesJustificationValidationAcceptingSuggestion,
} from "utils/validations-general-settings";
import OrderListItem from "./order-list-item";
import ShelfLifeListItem from "./shelf-life-list-item";
import StyledSuggestionsList from "./suggestions-list.styled";
import SuggestionsListHeader from "./suggestions-list-header";
import SuggestionsListItem from "./suggestions-list-item";

const SUGESTAO_MANUAL = 3;
class SuggestionsList extends Component {
  static contextType = OpenSuggestionPanelContext;

  constructor(props) {
    super(props);

    this.state = {
      itemsChecked: false,
      itemsShelflifeChecked: false,
      suggestionsCheckedData: [],
      shelflifeCheckedData: [],
      openStockReturnModal: false,
      stockReturnModalSuggestions: [],
      stockReturnCommonSuggestionIds: [],
    };

    this.tableListBodyElement = null;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.itemsChecked !== undefined &&
      this.props.itemsChecked !== prevProps.itemsChecked
    ) {
      this.setState({
        itemsChecked: this.props.itemsChecked,
      });
    }

    if (
      this.props.itemsShelflifeChecked !== undefined &&
      this.props.itemsShelflifeChecked !== prevProps.itemsShelflifeChecked
    ) {
      this.setState({
        itemsShelflifeChecked: this.props.itemsShelflifeChecked,
      });
    }
  }

  checkItem = (item, value) => {
    if (value) {
      this.setState(
        (prevState) => {
          const nextSelection = Array.from(
            new Set([...prevState.suggestionsCheckedData, item.Id])
          );
          return {
            suggestionsCheckedData: nextSelection,
            itemsChecked: this.areAllSelectableSuggestionsSelected(nextSelection),
          };
        },
        () => this.props.checkItem(this.state.suggestionsCheckedData)
      );
    } else {
      this.setState(
        (prevState) => {
          const nextSelection = prevState.suggestionsCheckedData.filter(
            (idMaterial) => idMaterial !== item.Id
          );
          return {
            suggestionsCheckedData: nextSelection,
            itemsChecked: this.areAllSelectableSuggestionsSelected(nextSelection),
          };
        },
        () => this.props.checkItem(this.state.suggestionsCheckedData)
      );
    }
  };

  checkShelfLife = (item, value) => {
    if (value) {
      this.setState(
        (state) => ({
          shelflifeCheckedData: [...state.shelflifeCheckedData, item],
        }),
        () => this.props.checkShelflifeItem(this.state.shelflifeCheckedData)
      );
    } else {
      this.setState(
        (state) => ({
          shelflifeCheckedData: state.shelflifeCheckedData.filter(
            (idMaterial) => idMaterial !== item.Id
          ),
        }),
        () => this.props.checkShelflifeItem(this.state.shelflifeCheckedData)
      );
    }
  };

  checkAllItems = () => {
    const { suggestionsCheckedData } = this.state;
    let _suggestionsCheckedData = [...suggestionsCheckedData];
    if (!this.areAllSelectableSuggestionsSelected(suggestionsCheckedData)) {
      _suggestionsCheckedData = this.getSelectableSuggestions().map((m) => m.Id);
    } else {
      _suggestionsCheckedData = [];
    }

    this.setState(
      () => ({
        itemsChecked: this.areAllSelectableSuggestionsSelected(_suggestionsCheckedData),
        suggestionsCheckedData: _suggestionsCheckedData,
      }),
      () => {
        this.props.checkAllItems(_suggestionsCheckedData);
      }
    );
  };

  checkAllItemsShelfLife = () => {
    const { shelflifeCheckedData } = this.state;
    let _shelflifeCheckedData = [...shelflifeCheckedData];
    if (!this.state.itemsShelflifeChecked) {
      _shelflifeCheckedData = this.props.data.map((m) => m);
    } else {
      _shelflifeCheckedData = [];
    }

    this.setState(
      (prevState) => ({
        itemsShelflifeChecked: !prevState.itemsShelflifeChecked,
        shelflifeCheckedData: _shelflifeCheckedData,
      }),
      () => {
        this.props.checkAllItems(_shelflifeCheckedData);
      }
    );
  };

  expandItem = (...params) => {
    this.props.expandItem(...params, this.tableListBodyElement);
  };

  excluirSugestoes = () => {
    const materialsChecked = [...this.state.suggestionsCheckedData];

    if (!materialsChecked.length) {
      this.props.handleFeedback(intl.get("feedbacks.oneSuggestionDelete"));
    } else {
      this.props.excluirSugestao(materialsChecked);
      this.setState({
        unCheckItems: true,
        suggestionsCheckedData: [],
      });
    }
  };

  aceitarSugestoes = () => {
    this.context?.closeSuggestionPanel?.();
    const listaSugestoes = this.props.data;
    const materialsChecked = [...this.state.suggestionsCheckedData];
    const selectedSuggestions = this.getSuggestionsByIds(materialsChecked);
    const stockReturnSuggestions = getStockReturnSuggestions(selectedSuggestions);
    const otherSuggestions = getOtherSuggestions(selectedSuggestions);

    if (selectedSuggestions.length > 0 && otherSuggestions.length === 0) {
      this.setState({
        openStockReturnModal: true,
        stockReturnModalSuggestions: this.mapStockReturnSuggestions(stockReturnSuggestions),
        stockReturnCommonSuggestionIds: [],
      });
      return;
    }

    const openStockReturnModalAfterAcceptance = stockReturnSuggestions.length
      ? () => this.setState({
          openStockReturnModal: true,
          stockReturnModalSuggestions: this.mapStockReturnSuggestions(stockReturnSuggestions),
          stockReturnCommonSuggestionIds: otherSuggestionIds,
        })
      : undefined;
    const otherSuggestionIds = otherSuggestions.map((suggestion) => suggestion.Id);
    if (
      !this.validarJustificativaSugestaoManualOuAlterada(otherSuggestionIds, listaSugestoes) &&
      usesJustificationValidationAcceptingSuggestion()
    ) {
      this.props.handleFeedback(intl.get("feedbacks.mandatoryJustification"));
      return;
    }

    if (!this.validarSomenteSugestoesManuaisSelecionadas(otherSuggestionIds, listaSugestoes)) {
      this.props.handleFeedback(intl.get("feedbacks.manualSuggestion"));
    } else {
      this.setState(
        {
          unCheckItems: true,
          suggestionsCheckedData: [],
        },
        () => {
          this.setState({ unCheckItems: false }, () => {
            this.props.verificarInconsistenciasDaSugestao(
              otherSuggestionIds,
              openStockReturnModalAfterAcceptance,
              Boolean(stockReturnSuggestions.length && !this.props.isExternalSuggestion)
            );
            this.props.checkItem([]);
          });
        }
      );
    }
  };

  getSelectableSuggestions = () =>
    this.props.data.filter(
      (item) =>
        (item.Coleta ?? item.SuggestionCollectDate) &&
        (item.DataEntregaDe ?? item.SuggestionDeliveryDate) &&
        item.naoSalvo !== true
    );

  getSuggestionsByIds = (ids) => this.props.data.filter((item) => ids.includes(item.Id));

  areAllSelectableSuggestionsSelected = (selectedIds) => {
    const selectableSuggestions = this.getSelectableSuggestions();

    return (
      selectableSuggestions.length > 0 &&
      selectableSuggestions.every((item) => selectedIds.includes(item.Id))
    );
  };

  mapStockReturnSuggestions = (suggestions) =>
    suggestions.map((item) => {
      const material =
        item.Material ??
        item.Materiais?.find((materialItem) => materialItem.Id === item.IdMaterial) ??
        item.Materiais?.[0];
      const supplier =
        item.Fornecedores?.find((supplierItem) => supplierItem.Id === item.IdFornecedor) ??
        material?.Fornecedores?.find((supplierItem) => supplierItem.Id === item.IdFornecedor);
      const materialSearch = material?.MaterialPesquisa;
      const materialDisplay = item.MaterialNumber ?? material?.Numero ?? materialSearch;
      const materialParts = typeof materialDisplay === "string" ? materialDisplay.split("-") : [];

      return {
        ...item,
        SuggestionType: item.SuggestionType ?? item.Tipo,
        SuggestionTypeDescription: item.SuggestionTypeDescription ?? item.TipoDescricao,
        LabeledFamilYCenterId:
          item.LabeledFamilYCenterId ?? this.props.idFamiliaRotuladaCentro,
        SupplierName:
          item.SupplierName ??
          item.Supplier ??
          item.Fornecedor ??
          supplier?.Descricao,
        Origin: item.Origin ?? item.Origem,
        BusinessUnit: item.BusinessUnit ?? item.Destination,
        BusinessUnitPlant: item.BusinessUnitPlant,
        BusinessUnitName: item.BusinessUnitName,
        MaterialNumber:
          item.MaterialNumber ??
          (materialParts.length > 1
            ? materialParts[0].trim()
            : material?.Numero ?? materialDisplay),
        MaterialName:
          item.MaterialName ??
          item.NomeMaterial ??
          (materialParts.length > 1 ? materialParts.slice(1).join("-").trim() : materialDisplay),
        Quantity: item.Quantity ?? item.Total ?? item.Quantidade ?? item.QuantidadeSolicitada,
        QuantityUnitOfMeasure: item.QuantityUnitOfMeasure ?? item.UnidadeMedida,
        Lot: item.Lot ?? item.Lote,
        LotRoudingUnit: item.LotRoudingUnit,
        SuggestionCollectDate: item.SuggestionCollectDate ?? item.Coleta,
        SuggestionDeliveryDate: item.SuggestionDeliveryDate ?? item.DataEntregaDe,
        SuggestionDeliveryTime: item.SuggestionDeliveryTime ?? item.HoraEntrega,
      };
    });

  closeStockReturnModal = () =>
    this.setState({
      openStockReturnModal: false,
      stockReturnCommonSuggestionIds: [],
    });

  handleStockReturnNotificationSuccess = async () => {
    this.setState({
      openStockReturnModal: false,
      stockReturnModalSuggestions: [],
      stockReturnCommonSuggestionIds: [],
      itemsChecked: false,
      suggestionsCheckedData: [],
    });
    this.props.checkItem?.([]);
    await this.props.onStockReturnNotificationSuccess?.();
  };

  validarJustificativaSugestaoManualOuAlterada = (materialsChecked, listaSugestoes) => {
    let isValid = true;
    materialsChecked.map((item, index) => {
      listaSugestoes.forEach((sugestao) => {
        if (sugestao.Id === item) {
          if (sugestao.IntStatus === SUGESTAO_MANUAL || sugestao.itemAlterado) {
            if (!sugestao.TipoJustificativaSugestaoManual) {
              isValid = false;
            }
          }
        }
      });
    });
    return isValid;
  };

  isSugestaoAutomaticaPedidoCompraChecada = (sugestao) =>
    sugestao.Tipo === "PC" && (sugestao.StatusSigla === "SA" || sugestao.StatusSigla === "SG");

  isSugestaoManualPedidoCompraChecada = (sugestao) =>
    sugestao.Tipo === "PC" && sugestao.StatusSigla === "SM";

  validarSomenteSugestoesManuaisSelecionadas = (materialsChecked, listaSugestoes) => {
    let possuiSugestaoAutomaticaPedidoCompraChecada = false;
    let possuiSugestaoManualPedidoCompraChecada = false;
    let pedidoDeTransferencia = false;
    const possuiSugestaoAutomatica = listaSugestoes.some(
      (sugestao) => sugestao.StatusSigla === "SA" || sugestao.StatusSigla === "SG"
    );

    listaSugestoes.forEach((sugestao) => {
      if (materialsChecked.includes(sugestao.Id)) {
        if (sugestao.Tipo === "PT") pedidoDeTransferencia = true;

        if (this.isSugestaoAutomaticaPedidoCompraChecada(sugestao))
          possuiSugestaoAutomaticaPedidoCompraChecada = true;

        if (this.isSugestaoManualPedidoCompraChecada(sugestao))
          possuiSugestaoManualPedidoCompraChecada = true;
      }
    });

    if (pedidoDeTransferencia) {
      return true;
    }

    return !(
      possuiSugestaoAutomatica &&
      possuiSugestaoManualPedidoCompraChecada &&
      !possuiSugestaoAutomaticaPedidoCompraChecada
    );
  };

  isHighlighted = (id) => {
    const { itemHighlighted } = this.props;
    return itemHighlighted > 0 && itemHighlighted == id;
  };

  createSuggestionShelfLife = () => {
    const materialsChecked = [...this.state.shelflifeCheckedData];

    this.props.acceptSuggestionsShelfLife(materialsChecked);
    this.setState(
      {
        unCheckShelflifeItems: true,
        shelflifeCheckedData: [],
      },
      () => {
        this.setState({ unCheckShelflifeItems: false }, () => {
          this.props.checkShelflifeItem([]);
        });
      }
    );
  };

  processHeaderRenderShelfLife = (itemsShelflifeChecked) => {
    return (
      <SuggestionsListHeader
        checked={itemsShelflifeChecked}
        checkItem={this.checkAllItemsShelfLife}
        idCheckbox="header-checkbox-shelf-life"
        isOrder={false}
      >
        <Row middle="xs">
          <Col xs={2}>
            <div className="header-item">{intl.get("commons.source")}</div>
          </Col>
          <Col xs={3}>
            <div className="header-item">{intl.get("commons.lot")}</div>
          </Col>
          <Col xs={2}>
            <div className="header-item">{intl.get("stocks.stockDetail.qtde")}</div>
          </Col>
          <Col xs={2}>
            <div className="header-item">{intl.get("stocks.stockDetail.venc")}</div>
          </Col>
          <Col xs={3}>
            <div className="header-item">{intl.get("stocks.stockDetail.descont")}</div>
          </Col>
        </Row>
      </SuggestionsListHeader>
    );
  };

  processHeaderRenderNormal = (itemsChecked, isOrder, isOrderBulk, isHourlyPlan) => {
    const getColumnSize = (param) => (param ? 1 : 2);
    const getColumnSizeVolume = (param) => (param ? 1 : 2);
    return (
      <SuggestionsListHeader
        checked={itemsChecked}
        checkItem={this.checkAllItems}
        idCheckbox="header-checkbox"
        isOrder={isOrder || isOrderBulk}
      >
        <Row middle="xs">
          <Col xs={getColumnSize(isOrder)}>
            <div className="header-item">
              {isOrder || isOrderBulk ? intl.get("requestOrders.step") : intl.get("commons.status")}
            </div>
          </Col>
          <Col xs={getColumnSize(isOrder)}>
            <div className="header-item">{intl.get("master-data.general-configuration.type")}</div>
          </Col>
          <Col xs={getColumnSize(isHourlyPlan)}>
            <div className="header-item">{intl.get("commons.collect")}</div>
          </Col>
          <Col xs={getColumnSize(isHourlyPlan)}>
            <div className="header-item">{intl.get("commons.delivery")}</div>
          </Col>
          {isHourlyPlan && (
            <Col xs={2}>
              <div className="header-item">{intl.get("commons.deliveryTime")}</div>
            </Col>
          )}
          <Col xs={getColumnSizeVolume(isOrderBulk)}>
            <div className="header-item">{intl.get("stocks.stockDetail.qtde")}</div>
          </Col>
          <Col xs={getColumnSizeVolume(isOrderBulk)}>
            <div className="header-item">
              {isOrder
                ? intl.get("commons.code")
                : isOrderBulk
                  ? intl.get("stocks.stockDetail.volumnPortal")
                  : "UN"}
            </div>
          </Col>
          {isOrderBulk && (
            <Col xs={2}>
              <div className="header-item">
                {intl.get("stocks.stockDetail.internalVolumnPortal")}
              </div>
            </Col>
          )}
          {isOrder && (
            <Col xs={2}>
              <div className="header-item">{getListCodeHeaderAbbreviated()}</div>
            </Col>
          )}
        </Row>
      </SuggestionsListHeader>
    );
  };

  processHeaderRender = () => {
    const { data, isOrder, isOrderBulk, isShelfLife, isHourlyPlan } = this.props;
    const { itemsChecked, itemsShelflifeChecked } = this.state;

    if (data && !!data.length && !isShelfLife) {
      return this.processHeaderRenderNormal(itemsChecked, isOrder, isOrderBulk, isHourlyPlan);
    } else if (data && !!data.length && isShelfLife) {
      return this.processHeaderRenderShelfLife(itemsShelflifeChecked);
    }
    return <div />;
  };

  processListRender = (item, index) => {
      const {
      changeValueSugestao,
      obterListaJustificativasSugestaoManual,
      listaJustificativasSugestaoManual,
      changeValueDeadline,
      salvarSugestao,
      excluirSugestao,
      cancelarSaldoPedidoVolume,
      showCancelConfirm,
      showFormOrder,
      isOrder,
      isOrderBulk,
      isShelfLife,
      isTransfer,
      itemExpanded,
      suggestionsExpandedList,
      shelflifeExpandedList,
      handleFeedback,
      changeValueOrder,
      saveOrder,
      changeHoraEntrega,
      isNewFlow,
      documentTypes,
      doors,
      isHourlyPlan,
      isExternalSuggestion,
      deliveryLocations,
      destination,
      idMaterialAtivo,
    } = this.props;

    const {
      suggestionsCheckedData,
      unCheckItems,
      unCheckShelflifeItems,
      itemsShelflifeChecked,
    } = this.state;

    if (!isOrder && !isOrderBulk && !isShelfLife) {
      return (
        <SuggestionsListItem
          key={item.Id}
          item={item}
          hasIcon
          itemIndex={index}
          checked={suggestionsCheckedData.includes(item.Id)}
          unCheckItem={unCheckItems}
          checkItem={this.checkItem}
          expandItem={this.expandItem}
          expanded={
            suggestionsExpandedList &&
            suggestionsExpandedList.findIndex((sugg) => sugg.Id === item.Id)
          }
          changeValueSugestao={changeValueSugestao}
          changeHoraEntrega={changeHoraEntrega}
          obterListaJustificativasSugestaoManual={obterListaJustificativasSugestaoManual}
          listaJustificativasSugestaoManual={listaJustificativasSugestaoManual}
          salvarSugestao={salvarSugestao}
          excluirSugestao={excluirSugestao}
          cancelarSaldoPedidoVolume={cancelarSaldoPedidoVolume}
          showCancelConfirm={showCancelConfirm}
          showFormOrder={showFormOrder}
          changeValueDeadline={changeValueDeadline}
          highlighted={this.isHighlighted(item.Id)}
          handleFeedback={handleFeedback}
          itemDimmed={item.StatusSigla === "AG" ? true : false}
          centro={this.props.centro}
          idUnidadeNegocio={this.props.idUnidadeNegocio}
          linhaProducaoCentro={this.props.linhaProducaoCentro}
          documentTypes={documentTypes}
          doors={doors}
          isHourlyPlan={isHourlyPlan}
          isExternalSuggestion={isExternalSuggestion}
          deliveryLocations={deliveryLocations}
          destination={destination}
          idFamiliaRotuladaCentro={this.props.idFamiliaRotuladaCentro}
          idMaterialAtivo={idMaterialAtivo}
        />
      );
    } else if (isOrder || isOrderBulk) {
      return (
        <OrderListItem
          key={item.Id}
          item={item}
          hasIcon
          isOrder={isOrder}
          isOrderBulk={isOrderBulk}
          isTransfer={isTransfer}
          itemIndex={index}
          checked={suggestionsCheckedData.includes(item.Id)}
          unCheckItem={unCheckItems}
          checkItem={this.checkItem}
          expandItem={this.expandItem}
          expanded={itemExpanded && (isOrder || isOrderBulk) && item.Id === itemExpanded.Id}
          changeValueOrder={changeValueOrder}
          salvarSugestao={salvarSugestao}
          excluirSugestao={excluirSugestao}
          cancelarSaldoPedidoVolume={cancelarSaldoPedidoVolume}
          showCancelConfirm={showCancelConfirm}
          showFormOrder={showFormOrder}
          changeValueDeadline={changeValueDeadline}
          highlighted={this.isHighlighted(item.Id)}
          itemDimmed={item.StatusSigla === "AG" ? true : false}
          saveOrder={saveOrder}
          usuarioComPermissaoParaCancelarPedidos={this.props.usuarioComPermissaoParaCancelarPedidos}
          itemExpanded={false}
          isNewFlow={isNewFlow}
          isHourlyPlan={isHourlyPlan}
          deliveryLocations={deliveryLocations}
          destination={destination}
        />
      );
    } else {
      return (
        <ShelfLifeListItem
          key={index}
          item={item}
          hasIcon
          isShelfLife={isShelfLife}
          itemIndex={index}
          checked={itemsShelflifeChecked}
          unCheckItem={unCheckShelflifeItems}
          expandItem={this.expandItem}
          checkShelflifeItem={this.checkShelfLife}
          expanded={
            shelflifeExpandedList?.findIndex((sugg) => sugg.Id === item.Id)
          }
        />
      );
    }
  };

  processNoData = () => {
    const { isOrder, isOrderBulk, isTransfer, isShelfLife } = this.props;

    if (isTransfer) return intl.get("stocks.emptyList.outgoingTransferProgress");
    else if (isOrder) return intl.get("stocks.emptyList.orderProgress");
    else if (isOrderBulk) return intl.get("stocks.emptyList.volume");
    else if (isShelfLife) return intl.get("stocks.emptyList.transfer");
    else return intl.get("stocks.emptyList.suggestion");
  };

  processFooter = () => {
    const { formValid, isOrder, isOrderBulk, isShelfLife } = this.props;

    if (!isOrder && !isOrderBulk && !isShelfLife) {
      return (
        <div className="table-list-footer">
          <div title={intl.get("stocks.stockDetail.deleteSuggestion")}>
            <ButtonIcon
              width="50px"
              buttonIcon={<IconTrash color={"var(--color-contrast-white)"} />}
              buttonType="danger"
              onClick={this.excluirSugestoes}
            />
          </div>
          <div title={intl.get("stocks.stockDetail.newSuggestion")}>
            <ButtonIcon
              buttonIcon={<IconAddSmall />}
              buttonType="secondary"
              onClick={this.props.createSuggestionManual}
              style={{ width: "50px" }}
            />
          </div>
          <div title={intl.get("stocks.stockDetail.accSuggestion")}>
            <Button
              value={intl.get("stocks.stockDetail.accSuggestion")}
              buttonType="primary"
              disabled={!formValid}
              onClick={this.aceitarSugestoes}
              style={{ width: "200px" }}
            />
          </div>
        </div>
      );
    } else if (isShelfLife) {
      return (
        <div className="table-list-footer">
          <div title={intl.get("stocks.stockDetail.addSuggestion")}>
            <Button
              width="200px"
              value={intl.get("stocks.stockDetail.addSuggestion")}
              type="primary"
              onClick={this.createSuggestionShelfLife}
            />
          </div>
        </div>
      );
    }
  };

  render() {
    const { data } = this.props;
    return (
      <StyledSuggestionsList>
        {this.processHeaderRender()}

        <div ref={(ref) => (this.tableListBodyElement = ref)} className="table-list-body">
          {data && data.length ? (
            data.map((item, index) => this.processListRender(item, index))
          ) : (
            <div className="no-data">
              <p>{this.processNoData()}</p>
            </div>
          )}
        </div>
        {this.processFooter()}
        {this.state.openStockReturnModal && (
          <StockReturnNotificationModal
            open
            suggestions={this.state.stockReturnModalSuggestions}
            onClose={this.closeStockReturnModal}
            onSuccess={this.handleStockReturnNotificationSuccess}
            onSubmit={(stockReturn) =>
              this.props.onAcceptStockReturn?.({
                suggestionIds: this.props.isExternalSuggestion
                  ? []
                  : this.state.stockReturnCommonSuggestionIds,
                stockReturn,
              })
            }
          />
        )}
      </StyledSuggestionsList>
    );
  }
}

SuggestionsList.propTypes = {
  data: PropTypes.array.isRequired,
  itemsChecked: PropTypes.bool,
  formValid: PropTypes.bool,
  expandItem: PropTypes.func,
  checkAllItems: PropTypes.func,
  createSuggestionManual: PropTypes.func,
  verificarInconsistenciasDaSugestao: PropTypes.func,
  salvarSugestao: PropTypes.func,
  excluirSugestao: PropTypes.func,
  showCancelConfirm: PropTypes.func,
  showFormOrder: PropTypes.func,
  changeValueSugestao: PropTypes.func,
  obterListaJustificativasSugestaoManual: PropTypes.func,
  changeValueDeadline: PropTypes.func,
  cancelarSaldoPedidoVolume: PropTypes.func,
  checkItem: PropTypes.func,
  isOrder: PropTypes.bool,
  isOrderBulk: PropTypes.bool,
  isShelfLife: PropTypes.bool,
  itemExpanded: PropTypes.object,
  suggestionsExpandedList: PropTypes.array,
  usuarioComPermissaoParaCancelarPedidos: PropTypes.func,
  checkShelflifeItem: PropTypes.func,
  changeHoraEntrega: PropTypes.func,
  isHourlyPlan: PropTypes.bool,
  itemsShelflifeChecked: PropTypes.bool,
  handleFeedback: PropTypes.func,
  itemHighlighted: PropTypes.number,
  acceptSuggestionsShelfLife: PropTypes.func,
  listaJustificativasSugestaoManual: PropTypes.any,
  isTransfer: PropTypes.bool,
  shelflifeExpandedList: PropTypes.array,
  changeValueOrder: PropTypes.func,
  saveOrder: PropTypes.func,
  isNewFlow: PropTypes.any,
  documentTypes: PropTypes.any,
  doors: PropTypes.any,
  isExternalSuggestion: PropTypes.any,
  deliveryLocations: PropTypes.array,
  destination: PropTypes.object,
  idFamiliaRotuladaCentro: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idMaterialAtivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onStockReturnNotificationSuccess: PropTypes.func,
  onAcceptStockReturn: PropTypes.func,
  centro: PropTypes.any,
  idUnidadeNegocio: PropTypes.string,
  linhaProducaoCentro: PropTypes.string,
};

export default SuggestionsList;
